/* Hauser MX — la foto que viaja de la tarjeta a la ficha (Fase 8).
 *
 * Horizon ya trae toda la maquinaria de View Transitions entre documentos
 * (assets/view-transitions.js), pero venía apagada por ajuste y, sobre todo,
 * NADIE le decía qué elemento de la página A se corresponde con cuál de la
 * página B. Sin esa correspondencia el navegador solo puede hacer un fundido
 * de página entera.
 *
 * Aquí se establece esa pareja: al hacer clic en una tarjeta se le pone un
 * `view-transition-name` a SU foto, y en la ficha se le pone el mismo nombre a
 * la foto principal de la galería. El navegador ve dos elementos con el mismo
 * nombre en dos documentos y los interpola: la foto de la tarjeta crece y se
 * convierte en la de la ficha.
 *
 * Por qué el nombre se pone al hacer clic y no de entrada: `view-transition-
 * name` debe ser ÚNICO en el documento. Un catálogo con 15 tarjetas marcadas
 * de antemano tendría 15 elementos compitiendo por el mismo nombre y el
 * navegador descarta la transición entera sin avisar.
 *
 * Degrada solo: los navegadores sin View Transitions (Firefox y Safari
 * antiguos) navegan normal, sin ningún salto ni pantalla en blanco.
 */
(function () {
  'use strict';

  var H = window.Hauser;
  if (!H) return;

  /* La API es lo que decide si esto tiene sentido, no el nivel del motor: es
     una transición de navegación, no un efecto decorativo. Aun así se respeta
     `flat`, porque ahí el visitante pidió menos movimiento. */
  if (!document.startViewTransition || H.tier === 'flat') return;

  var NOMBRE = 'hauser-foto-propiedad';

  /* ── Salida: marcar la foto de la tarjeta que se acaba de pulsar ──── */

  document.addEventListener(
    'click',
    function (e) {
      var enlace = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!enlace) return;

      var tarjeta = enlace.closest('[data-hauser-card]');
      if (!tarjeta) return;

      /* Se limpia cualquier marca previa: si el visitante vuelve atrás y pulsa
         otra tarjeta, quedarían dos con el mismo nombre y la transición se
         cancelaría en silencio. */
      document.querySelectorAll('[data-hauser-vt]').forEach(function (el) {
        el.style.viewTransitionName = '';
        el.removeAttribute('data-hauser-vt');
      });

      var media = tarjeta.querySelector('.hauser-card-propiedad__media');
      if (!media) return;
      media.style.viewTransitionName = NOMBRE;
      media.setAttribute('data-hauser-vt', '');
    },
    /* En fase de captura: hay que marcar ANTES de que Horizon intercepte la
       navegación, o el snapshot de salida se toma sin el nombre puesto. */
    true
  );

  /* ── Llegada: nombrar la foto principal de la ficha ───────────────── */

  function marcarFicha() {
    var galeria = document.querySelector('.hauser-ficha__galeria');
    if (!galeria) return;

    /* La galería de Horizon monta su slideshow de forma asíncrona, así que la
       primera diapositiva puede no existir todavía cuando corre esto. Se
       intenta y, si no está, se espera a que aparezca. */
    var poner = function () {
      var primera =
        galeria.querySelector('slideshow-slide:not([hidden]) img') ||
        galeria.querySelector('img');
      if (!primera) return false;
      primera.style.viewTransitionName = NOMBRE;
      return true;
    };

    if (poner()) return;

    var obs = new MutationObserver(function () {
      if (poner()) obs.disconnect();
    });
    obs.observe(galeria, { childList: true, subtree: true });
    /* Tope de seguridad: si en 3 s la galería no ha montado, se deja de
       observar en vez de mantener un observer vivo el resto de la visita. */
    setTimeout(function () { obs.disconnect(); }, 3000);
  }

  if (document.querySelector('.hauser-ficha')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', marcarFicha, { once: true });
    } else {
      marcarFicha();
    }
  }
})();
